var GetClinicMessagesRequest = /** @class */ (function () {
    function GetClinicMessagesRequest(_a) {
        var PublicToken = _a.PublicToken;
        this.Action = 'GetClinicMessages';
        this.PublicToken = PublicToken;
    }
    return GetClinicMessagesRequest;
}());
export { GetClinicMessagesRequest };
